//@ts-ignore
import { tw } from "@careinfo/tailwind";

const UrlField = (props: any) => {
  const {
    placeholder = "https://example.com",
    value,
    register,
    errors,
    label,
    disabled = false,
  } = props;

  return (
    <div className={tw`w-full text-left mt-1`}>
      <label>{label}</label>

      <input
        type="url"
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
        defaultValue={value}
        {...register}
        className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
      />

      {errors && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
      )}
    </div>
  );
};

export default UrlField;
